/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest interface.
 */
export function instanceOfFxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest(value) {
    if (!('Receipt' in value) || value['Receipt'] === undefined)
        return false;
    if (!('DeveloperPayload' in value) || value['DeveloperPayload'] === undefined)
        return false;
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSON(json) {
    return FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Receipt': json['Receipt'],
        'DeveloperPayload': json['DeveloperPayload'],
        'Sku': json['Sku'],
    };
}
export function FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSON(json) {
    return FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Receipt': value['Receipt'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest.js.map